module.exports = __webpack_public_path__ + "5f2507b563b32a9a730a080852bc4a2c.jpg";